export interface HelpdeskWidgetConfiguration {
  apiBase: string;
  source: string;
  supportUrl: string;
  locale: 'en' | 'ru';
  initialOpen?: boolean;
  bubbleIdentity?: boolean;
}

export const HELPDESK_PRIVACY_POLICY_URL = 'https://move.molchanovs.com/privacy_policy';

export function scriptConfiguration(script: HTMLScriptElement): HelpdeskWidgetConfiguration {
  const api = new URL(script.dataset.apiBase ?? '');
  if (
    api.protocol !== 'https:' ||
    api.pathname !== '/' ||
    api.search !== '' ||
    api.hash !== '' ||
    api.username ||
    api.password
  )
    throw new Error('The widget requires an HTTPS API origin.');
  const source = script.dataset.source?.trim();
  if (!source || source.length > 200) throw new Error('The widget requires a valid data-source.');
  const hostedScript = new URL(script.src);
  if (hostedScript.protocol !== 'https:') throw new Error('The widget script requires HTTPS.');
  const locale = script.dataset.locale === 'ru' ? 'ru' : 'en';
  return {
    apiBase: api.origin,
    source,
    supportUrl: new URL(`/${locale}/?helpdesk=open`, hostedScript.origin).href,
    locale,
    bubbleIdentity: script.dataset.bubbleIdentity === 'true',
  };
}
